import {
  CreateVesselServiceCommand,
  UpdateVesselServiceCommand,
  VesselServiceResponseDto,
} from '@planning/app/api'
import { VesselServiceItemStore } from '@planning/rt-stores/vesselService/VesselServiceItemStore'
import { vesselServiceService } from '@planning/services'
import _ from 'lodash'
import { action, computed, makeObservable, observable } from 'mobx'

export interface VesselServiceFormData {
  id?: number
  serviceId: string
  name: string
  portRotation: string[]
}

export class VesselServiceViewStore {
  isFormDialogOpen = false
  isDeleteDialogOpen = false

  dataToBeEdited?: VesselServiceResponseDto

  constructor(private readonly vesselServiceItemStore: VesselServiceItemStore) {
    makeObservable(this, {
      dataToBeEdited: observable,
      isFormDialogOpen: observable,
      isDeleteDialogOpen: observable,

      items: computed,

      toggleFormDialog: action,
      toggleDeleteDialog: action,
      setDataToBeEdited: action,
    })
  }

  get items() {
    return _.values(this.vesselServiceItemStore.elements).map(item => ({ ...item.data }))
  }

  setDataToBeEdited = (data?: VesselServiceResponseDto) => (this.dataToBeEdited = data)

  toggleFormDialog = (shouldOpen: boolean, data?: VesselServiceResponseDto) => {
    this.isFormDialogOpen = shouldOpen
    this.setDataToBeEdited(data)
  }

  toggleDeleteDialog = (shouldOpen: boolean) => (this.isDeleteDialogOpen = shouldOpen)

  onDelete = async (id: number) => {
    this.toggleDeleteDialog(false)
    await vesselServiceService.delete(id)
  }

  onSubmit = async (data: VesselServiceFormData) => {
    const isEditMode = !!data.id

    if (isEditMode) {
      const cmd: UpdateVesselServiceCommand = {
        ...data,
        id: data.id!,
      }
      await vesselServiceService.update(cmd)
    } else {
      const cmd: CreateVesselServiceCommand = {
        ...data,
      }
      await vesselServiceService.create(cmd)
    }
  }
}
